export function IlustracaoPrancheta(props) {
  return (
    <svg
      width={69}
      height={70}
      viewBox="0 0 69 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.708 57.342c14.147 1.54 55.358-12.96 38.04-37.125-17.319-24.165-50.25.352-51.951 14.864-1.698 14.513 3.595 21.141 13.91 22.261z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.995 52.39h30.28V16.606h-30.28V52.39z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.791 13.801a3.71 3.71 0 00-3.516-2.548 3.709 3.709 0 00-3.514 2.548h-6.052v5.767h19.247v-5.767h-6.165zM50.596 44.526h5.407v-23.68h-5.407v23.68z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.805 51.53a.46.46 0 01-.46.459H15.32a.46.46 0 01-.46-.46V17.92a.46.46 0 01.46-.46h2.802a.46.46 0 01.46.46v1.4c0 .52.423.94.942.94H39.14c.519 0 .941-.42.941-.94v-1.4a.46.46 0 01.46-.46h2.803a.46.46 0 01.46.46v33.61zm-23.34-36.412a.46.46 0 01.46-.46h4.46a.943.943 0 00.888-.625 3.258 3.258 0 013.06-2.175c1.365 0 2.595.873 3.058 2.173a.947.947 0 00.888.628h4.46a.46.46 0 01.46.459v2.801a.46.46 0 01-.46.46H20.924a.46.46 0 01-.46-.46v-2.801zm22.88.46h-2.803a.46.46 0 01-.46-.46v-1.4a.942.942 0 00-.941-.942h-4.972a.458.458 0 01-.398-.23 5.15 5.15 0 00-4.439-2.57c-1.82 0-3.52.985-4.438 2.57a.458.458 0 01-.398.23h-4.973a.942.942 0 00-.941.941v1.4a.46.46 0 01-.46.46h-2.803a2.345 2.345 0 00-2.342 2.342v33.61a2.345 2.345 0 002.342 2.341h28.026a2.345 2.345 0 002.343-2.34V17.918a2.345 2.345 0 00-2.343-2.341z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.14 26.781h-7.006a.942.942 0 00-.941.941c0 .519.422.94.941.94h7.007c.519 0 .941-.421.941-.94a.942.942 0 00-.941-.94zM39.14 35.183h-7.006a.942.942 0 00-.941.94c0 .52.422.942.941.942h7.007a.942.942 0 000-1.881zM39.14 43.586h-7.006a.942.942 0 00-.941.941c0 .519.422.94.941.94h7.007c.519 0 .941-.421.941-.94a.942.942 0 00-.941-.94z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.016 43.126a.46.46 0 01-.46.46h-2.804a.46.46 0 01-.459-.46V22.12a.46.46 0 01.46-.46h2.803a.46.46 0 01.46.46v21.006zm.941-23.347a.46.46 0 01-.46-.46v-2.8a.942.942 0 00-.941-.941h-2.804a.943.943 0 00-.94.94v2.802a.46.46 0 01-.46.459.942.942 0 00-.941.94v23.808c0 .519.422.94.941.94a.46.46 0 01.46.46v2.8c0 .52.422.942.94.942a.46.46 0 01.46.46v2.8a.943.943 0 001.883 0v-2.8a.46.46 0 01.46-.46.942.942 0 00.942-.941v-2.801a.46.46 0 01.46-.46.942.942 0 00.941-.94V20.719a.942.942 0 00-.941-.94z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.532 23.98c-.3 0-.575.138-.755.377l-3.234 4.31a.462.462 0 01-.336.183h-.033a.457.457 0 01-.324-.134l-1.661-1.66a.936.936 0 00-.666-.275.943.943 0 00-.666 1.606l2.771 2.768a.635.635 0 01.158.133l.034.015.087.04c.025.014.049.028.073.04l.023.015a.965.965 0 00.312.066h.017a.942.942 0 00.363-.085l.03-.021c.03-.022.058-.044.09-.064.031-.02.063-.038.096-.056l.059-.035a.6.6 0 01.144-.162l4.17-5.557a.93.93 0 00.178-.696.934.934 0 00-.368-.62.931.931 0 00-.562-.188zM26.53 32.383c-.299 0-.573.136-.753.376l-3.234 4.31a.462.462 0 01-.336.183l-.033.001a.457.457 0 01-.324-.135l-1.661-1.66a.936.936 0 00-.666-.275.943.943 0 00-.666 1.606l2.771 2.769a.633.633 0 01.158.132l.034.015a1.696 1.696 0 01.16.08l.023.015a.965.965 0 00.312.066h.017a.959.959 0 00.363-.085l.03-.02c.03-.023.058-.045.09-.065.031-.02.063-.038.096-.056.019-.012.042-.024.059-.036a.581.581 0 01.144-.163l4.17-5.555a.937.937 0 00-.753-1.503zM26.532 40.786c-.3 0-.575.136-.755.376l-3.234 4.31a.458.458 0 01-.336.182h-.033a.46.46 0 01-.324-.133l-1.661-1.66a.936.936 0 00-.666-.275.943.943 0 00-.666 1.606l2.771 2.768a.705.705 0 01.093.066.667.667 0 01.065.067l.034.014.087.042.073.04.023.014a.962.962 0 00.333.066.956.956 0 00.36-.085l.028-.022c.03-.021.06-.043.091-.063.031-.02.063-.038.096-.057.019-.01.042-.024.059-.035a.576.576 0 01.144-.163l4.17-5.555c.15-.2.213-.448.178-.695a.932.932 0 00-.368-.62.931.931 0 00-.562-.188z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.342 13.625a.942.942 0 10-.941-.94c0 .518.422.94.94.94z"
        fill="#FEC1AF"
      />
    </svg>
  );
}
